import { DestroyRef, inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  public key: string | null = '';
  private destroyRef = inject(DestroyRef);

  getRecaptchaToken(action: string): Observable<string | null> {
    return new Observable<string | null>((observer) => {
      const siteKey = this.key;
      if (!siteKey) {
        console.error('Recaptcha site key is missing');
        observer.next(null);
        observer.complete();
        return;
      }
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const grecaptchaObj = (window as any).grecaptcha;
        const enterprise = grecaptchaObj?.enterprise;
        if (
          !grecaptchaObj ||
          !enterprise ||
          typeof enterprise.ready !== 'function' ||
          typeof enterprise.execute !== 'function'
        ) {
          console.warn('grecaptcha.enterprise is not ready or misconfigured');
          observer.next(null);
          observer.complete();
          return;
        }
        enterprise.ready(() => {
          try {
            enterprise
              .execute(siteKey, { action })
              .then((token: string) => {
                observer.next(token);
                observer.complete();
              })
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              .catch((error: any) => {
                console.error('Recaptcha execute() catch:', error);
                observer.next(null);
                observer.complete();
              });
          } catch (executeErr) {
            console.error('Recaptcha execute() threw:', executeErr);
            observer.next(null);
            observer.complete();
          }
        });
      } catch (outerErr) {
        console.error('Recaptcha init failure:', outerErr);
        observer.next(null);
        observer.complete();
      }
    }).pipe(takeUntilDestroyed(this.destroyRef));
  }
}
